import { createEnum } from "@redotech/zod-util/zod-enum";

/**
 * OMS fulfillment events that can disallow order edits once they occur. Kept in
 * a dependency-free leaf module so the order editing settings slice (Zod
 * schemas) and `flat-team-settings` can use it without creating a circular
 * import.
 */
export enum OrderEditingDisallowEvent {
  LABEL_CREATED = "label_created",
  PACKING_SLIP_PRINTED = "packing_slip_printed",
  PICK_SESSION_CREATED = "pick_session_created",
}

export const OrderEditingDisallowEventZod = createEnum([
  OrderEditingDisallowEvent.LABEL_CREATED,
  OrderEditingDisallowEvent.PACKING_SLIP_PRINTED,
  OrderEditingDisallowEvent.PICK_SESSION_CREATED,
]);
